module.exports = __webpack_public_path__ + "img/download-app-logo.ec238689.svg";